import { useState, useEffect } from 'react'
import { api } from '../../Controllers/api'
import { AnalyticEvent } from '../../analytics/GoogleAnalytics'

export function useHauls() {
  const [haulsList, setHaulsList] = useState()
  const [error, setError] = useState()

  const refreshHauls = () => {
    api
      .get(`hauls`)
      .then(({ data }) => {
        setHaulsList(data)
        // The function call setHaulsListFull below was breaking this file so I commented it out
        // setHaulsListFull(data)
        // setLoading(false)
      })
      .catch(err => setError(err))
  }

  useEffect(() => {
    refreshHauls()
  }, [])

  return { haulsList, refreshHauls, error }
}

export function usePitslipActionModal() {
  const [pitslipActionModal, setVisible] = useState(false)

  const handlePitslipActionModal = () => {
    setVisible(true)
    setTimeout(() => {
      setVisible(false)
    }, 2500)
  }
  return { pitslipActionModal, handlePitslipActionModal }
}

export function useLoadActionModal() {
  const [loadActionModal, setVisible] = useState(false)
  const [loadAction, setLoadAction] = useState('delete')

  const handleLoadActionModal = () => {
    setVisible(true)
    setTimeout(() => {
      setVisible(false)
    }, 2500)
  }

  return { loadActionModal, handleLoadActionModal, loadAction, setLoadAction }
}

export function useDeleteLoadModal() {
  const [loadDeleteModal, setVisible] = useState(false)

  const handleDeleteLoadModal = () => {
    if (!loadDeleteModal) {
      AnalyticEvent('Loads', 'DeleteContactButtonPress')
    }
    setVisible(!loadDeleteModal)
  }

  return { loadDeleteModal, handleDeleteLoadModal }
}
